import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  private basePath: string = `${environment.signalrHubUrl}`;
  private hubConnection: signalR.HubConnection
  public startConnection(): Observable<boolean> {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Debug)  // add this for diagnostic clues
      .withUrl(this.basePath, {
        skipNegotiation: true,  // skipNegotiation as we specify WebSockets
        transport: signalR.HttpTransportType.WebSockets, // force WebSocket transport
      })
      .build();

    return new Observable<boolean>((observer) => {
      this.hubConnection
        .start()
        .then(() => {
          console.log('Connection started');
          observer.next(true);
        })
        .catch(err => {
          console.log('Error while starting connection: ' + err);
          observer.next(false);
        })
    });
  }

  public joinUserGroup = (userName: string) => {
    if (this.hubConnection.state === signalR.HubConnectionState.Connected) {
      // Invoke the server-side method "AddToUserGroup" and pass the userName
      this.hubConnection.invoke('AddToUserGroup', userName)
        .catch(err => console.error('Error joining group: ', err));
    } else {
      console.log('Hub connection not started.');
    }
  };

  // Method to receive messages
  public registerGroupJoinedListener = () => {
    this.hubConnection.on('UserGroupJoined', (message) => {
      console.log(message);
    });
  };


  receiveUpdatedQuotation(): Observable<string> {
    return new Observable<string>((observer) => {
      this.hubConnection.on('ReceiveUpdatedQuotation', (message: string) => {
        observer.next(message);
      });
    });
  }

  public stopConnection() {
    this.hubConnection
      .stop()
      .then(() => console.log('Connection stopped'))
      .catch(err => console.log('Error while stopping connection: ' + err))
  }

  public registerUserGroupMessageListener = () => {
    this.hubConnection.on('ReceiveUserMessage', (message) => {
      console.log('Received message for my group:', message);
      // You can handle the message here, e.g., show a toast notification
    });
  };

}